<template>
  <div class="qrcodes">
    <page-header title="QR Codes" />
    <page-section>
      <v-row no-gutters>
        <v-col class="mb-4" cols="12">
          <div class="subtitle-2 mt-3 grey--text text--darken-2">
            {{ $t("voce_possui") }}
            {{ getAccounts.pessoa.length + getAccounts.pet.length }}
            {{
              getAccounts.pessoa.length + getAccounts.pet.length > 1
                ? $t("cadastrados")
                : $t("cadastrado")
            }}
          </div>
          <div
            style="height: 460px; overflow: hidden auto"
            class="mt-6"
            :style="
              $vuetify.breakpoint.smAndDown
                ? 'height: calc(100vh - 230px); overflow: hidden auto;'
                : ''
            "
          >
            <div
              v-if="getAccounts.pessoa.length > 0"
              class="px-3 text-center pa-0 py-2"
              style="
                position: sticky;
                top: 0;
                width: 100%;
                z-index: 1;
                background-color: white;
                border-bottom: solid 1px #e6e6e6;
              "
            >
              <span
                class="
                  text-uppercase
                  caption
                  font-weight-bold
                  grey--text
                  text--darken-1
                  pa-0
                  ma-0
                "
              >
                {{ getAccounts.pessoa.length }} -
                {{
                  getAccounts.pessoa.length > 1
                    ? $t("braceletes")
                    : $t("bracelete")
                }}
              </span>
            </div>
            <v-card
              v-for="(item, i) in getAccounts.pessoa"
              elevation="0"
              :key="'pessoa-' + i"
              class="mb-0"
              tile
              style="border-bottom: solid 1px #e6e6e6"
            >
              <v-card-text>
                <v-row>
                  <v-col cols="1" class="d-flex align-center pa-0 pl-1">
                    <v-icon :size="$vuetify.breakpoint.mdAndUp ? 40 : 25">
                      mdi-qrcode
                    </v-icon>
                  </v-col>
                  <v-col cols="11">
                    <v-row no-gutters>
                      <v-col cols="2" class="caption">Nº</v-col>
                      <v-col cols="10" class="caption">{{ i + 1 }}</v-col>
                      <v-col cols="2" class="caption">ID:</v-col>
                      <v-col cols="10" class="caption">
                        {{ getID(item.uid) }}
                      </v-col>
                      <v-col cols="2" class="caption">{{ $t("Tipo") }}:</v-col>
                      <v-col cols="10" class="caption">
                        {{ getType(item.tipo) }}
                      </v-col>
                      <v-col cols="2" class="caption">{{ $t("Nome") }}:</v-col>
                      <v-col cols="10" class="caption">
                        {{ item.nome || $t("Sem_Nome") | toPT_BRCapitalize }}
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
            <div
              v-if="getAccounts.pet.length > 0"
              class="px-3 text-center pa-0 py-2"
              style="
                position: sticky;
                top: 0;
                width: 100%;
                z-index: 1;
                background-color: white;
                border-bottom: solid 1px #e6e6e6;
              "
            >
              <span
                class="
                  text-uppercase
                  caption
                  font-weight-bold
                  grey--text
                  text--darken-1
                  pa-0
                  ma-0
                "
              >
                {{ getAccounts.pet.length }} -
                {{
                  getAccounts.pet.length > 1 ? $t("pingentes") : $t("pingente")
                }}
              </span>
            </div>
            <v-card
              v-for="(item, i) in getAccounts.pet"
              elevation="0"
              :key="'pet-' + i"
              class="mb-0"
              tile
              style="border-bottom: solid 1px #e6e6e6"
            >
              <v-card-text>
                <v-row>
                  <v-col cols="1" class="d-flex align-center pa-0 pl-1">
                    <v-icon :size="$vuetify.breakpoint.mdAndUp ? 40 : 25">
                      mdi-qrcode
                    </v-icon>
                  </v-col>
                  <v-col cols="11">
                    <v-row no-gutters>
                      <v-col cols="2" class="caption">Nº</v-col>
                      <v-col cols="10" class="caption">{{ i + 1 }}</v-col>
                      <v-col cols="2" class="caption">ID:</v-col>
                      <v-col cols="10" class="caption">
                        {{ getID(item.uid) }}
                      </v-col>
                      <v-col cols="2" class="caption">{{ $t("Tipo") }}:</v-col>
                      <v-col cols="10" class="caption">
                        {{ getType(item.tipo) }}
                      </v-col>
                      <v-col cols="2" class="caption">{{ $t("Nome") }}:</v-col>
                      <v-col cols="10" class="caption">
                        {{ item.nome || $t("Sem_Nome") | toPT_BRCapitalize }}
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
            <v-card
              v-if="$store.state.auth.statusAccounts === 1"
              elevation="0"
              tile
              style="
                position: sticky;
                top: -8px;
                width: 100%;
                background-color: #fff;
              "
            >
              <v-card-text>
                <v-progress-circular
                  indeterminate
                  size="10"
                  width="1"
                  class="mr-2 grey--text"
                />
                <i class="caption grey--text">{{ $t("atualizando") }}</i>
              </v-card-text>
            </v-card>
          </div>
        </v-col>
      </v-row>
    </page-section>
  </div>
</template>

<script>
import PageHeader from "@/components/headers/page-header";
import PageSection from "@/components/sections/page-section";
export default {
  metaInfo: {
    titleTemplate: "QR Codes | %s",
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (!vm.$store.state.auth.user.token) {
        vm.$router.push("/");
      }
    });
  },
  components: { PageSection, PageHeader },
  computed: {
    getAccounts() {
      return {
        pessoa: this.$store.state.auth.accounts.pessoa || [],
        pet: this.$store.state.auth.accounts.pet || [],
      };
    },
  },
  methods: {
    getType(type) {
      return type === "pessoa"
        ? this.$t("Bracelete")
        : type === "pet"
        ? this.$t("Pingente")
        : "";
    },
    getID(id) {
      return id.split("/")[2];
    },
  },
};
</script>

<style scoped></style>
